








































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ButtonType } from '@getaccept/lib-ui';
import { SignatureConstants } from '@getaccept/lib-shared/src/signature/constants/signature.constants';
import type { Entity } from '@getaccept/lib-shared/src/entity/signing-site/types/entity';
import type { SigningPageUser } from '@getaccept/lib-shared/src/types/signing-page-user';
import type { SigningPageDocument } from '@getaccept/lib-shared/src/types/signing-page-document';
import { SigningHelper } from '../../helpers/signing.helper';
import SignConsent from './ESignConsent.vue';

@Component({
  components: {
    SignConsent,
  },
  data: () => ({
    ButtonType,
    initialsMaxLength: SignatureConstants.initialsMaxLength,
  }),
})
export default class VerifyClick extends Vue {
  @Prop() entity!: Entity;
  @Prop() sender!: SigningPageUser;
  @Prop() document!: SigningPageDocument;
  @Prop() signText: string;
  @Prop() reviewPending: boolean;
  @Prop() hasInitials: boolean;

  initials = '';
  initialsValidation = '';
  showConsent = false;

  @Watch('initials')
  watchInitials() {
    this.initialsValidation = '';
  }

  get isSigningInitials(): boolean {
    return this.document.isSigningInitials === 1;
  }

  handleShowConsent(): void {
    this.showConsent = true;
  }

  handleSignDocument() {
    if (this.reviewPending) {
      this.close();
      return;
    }

    if (!this.isSigningInitials || this.hasInitials) {
      this.$emit('sign', '');
      return;
    }

    this.initialsValidation = SigningHelper.validateInitials(this.initials);
    if (!this.initialsValidation) {
      this.$emit('sign', this.initials);
    }
  }

  close() {
    this.$emit('close');
  }
}
